import {
	CREATE_SPIN_RATE_REQUEST,
	CREATE_SPIN_RATE_SUCCESS,
	CREATE_SPIN_RATE_FAIL,
	FETCH_SPIN_RATES_REQUEST,
	FETCH_SPIN_RATES_SUCCESS,
	FETCH_SPIN_RATES_FAIL,
	UPDATE_SPIN_RATE_REQUEST,
	UPDATE_SPIN_RATE_SUCCESS,
	UPDATE_SPIN_RATE_FAIL,
	DELETE_SPIN_RATE_REQUEST,
	DELETE_SPIN_RATE_SUCCESS,
	DELETE_SPIN_RATE_FAIL,
	FETCH_SPIN_RATE_REQUEST,
	FETCH_SPIN_RATE_SUCCESS,
	FETCH_SPIN_RATE_FAIL,
} from "../constants/spinTheWheelRate";

function createSpinRateReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}

	switch (action.type) {
		case CREATE_SPIN_RATE_REQUEST:
			return { loading: true };
		case CREATE_SPIN_RATE_SUCCESS:
			return { loading: false, success: true, spinRate: action.payload.data };
		case CREATE_SPIN_RATE_FAIL:
			return { loading: false, success: false, error: action.payload };
		default:
			return state;
	}
}

function fetchSpinRatesReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			spinRateUpdated: false,
			error: null,
			spinRateDeleted: false,
		};
	}
	switch (action.type) {
		case FETCH_SPIN_RATES_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SPIN_RATES_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				spinRates: action.payload,
			};
		case FETCH_SPIN_RATES_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function updateSpinRateReducer(state, action) {
	if (typeof state === "undefined") {
		state = { status: "IDLE", error: null, spinRateUpdated: false };
	}
	switch (action.type) {
		case UPDATE_SPIN_RATE_REQUEST:
			return { loading: true };
		case UPDATE_SPIN_RATE_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				spinRateUpdated: true,
			};
		case UPDATE_SPIN_RATE_FAIL:
			return { loading: false, spinRateUpdated: false, error: action.payload };
		default:
			return state;
	}
}

function deleteSpinRateReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case DELETE_SPIN_RATE_REQUEST:
			return { loading: true };
		case DELETE_SPIN_RATE_SUCCESS:
			return {
				loading: false,
				spinRateDeleted: true,
			};
		case DELETE_SPIN_RATE_FAIL:
			return { loading: false, spinRateDeleted: false, error: action.payload };
		default:
			return state;
	}
}

function fetchSpinRateReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
			spinRateUpdated: false,
			spinRateDeleted: false,
		};
	}

	switch (action.type) {
		case FETCH_SPIN_RATE_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SPIN_RATE_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				spinRate: action.payload,
			};
		case FETCH_SPIN_RATE_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

export {
	createSpinRateReducer,
	fetchSpinRatesReducer,
	updateSpinRateReducer,
	deleteSpinRateReducer,
	fetchSpinRateReducer,
};
